import { FC } from 'react';
import { Provider } from 'react-redux';
import { store } from './store';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { Routers } from './routers';
import { ToastContainer } from '@components/RootNotificationWrapper';
import { PortalProvider } from './context/portal';

export interface AppProps {
  module?: Nullable<string>;
  companyid?: Nullable<string>;
  baseroute?: Nullable<string>;
  companyaddressid?: Nullable<string>;
  updatelocation?: Nullable<string>;
  externalrouteselectionid?: Nullable<string>;
  userid?: Nullable<string>;
}

export const App: FC<AppProps> = ({
  module,
  companyid,
  baseroute,
  companyaddressid,
  updatelocation,
  userid,
  externalrouteselectionid,
}) => {
  return (
    <Provider store={store}>
      <BrowserRouter basename={baseroute || '/'}>
        <PortalProvider value={{ module, companyId: companyid, companyAddressId: companyaddressid, userid }}>
          <>
            <Routers updatelocation={updatelocation} externalRouteSelectionId={externalrouteselectionid} />
            <ToastContainer />
          </>
        </PortalProvider>
      </BrowserRouter>
    </Provider>
  );
};
